import PropTypes from 'prop-types'
import React, {useState, useEffect} from 'react'
import i18n from 'i18next'
import {connect} from 'react-redux'
import actions from 'redux-auto'
import AusbildungsplanKachel from '#components/o/Uebersicht/AusbildungsplanKachel'
import Loading from '#components/a/Loading'
import UserInfoHOC from '#components/HOC/UserInfoHOC'
import Headline from '#components/a/Headline'
import Api from '#services/api'

function UebersichtAusbildungsplan({userInfo}) {
  const {firstname} = userInfo
  const [ausbildungsplanModel, setAusbildungsplanModel] = useState(undefined)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (ausbildungsplanModel === undefined) {
      setAusbildungsplanModel(null)
      setIsLoading(true)
      Api.readAusbildungsplanForAusbilderDashboard()
        .then(result => {
          setAusbildungsplanModel(result)
          setIsLoading(false)
        })
        .catch(error => {
          actions.error.writeError({error})
          setIsLoading(false)
        })
    }
  }, [ausbildungsplanModel])

  return (
    <div className="uebersicht">
      <div className="header-wrapper">
        <Headline importance={1} modifier="section" text={i18n.t('meineausbildung_page_title', [firstname])} />
      </div>
      <div className="uebersicht__page">
        {isLoading ? <Loading /> : <AusbildungsplanKachel ausbildungsplanModel={ausbildungsplanModel} showAllItems />}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  userId: state.authentication.id,
})

UebersichtAusbildungsplan.propTypes = {
  userInfo: PropTypes.shape({
    firstname: PropTypes.string,
  }).isRequired,
}

export default connect(mapStateToProps)(UserInfoHOC(UebersichtAusbildungsplan))
